import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import { CustomTooltip } from "src/components/CustomTooltip";
import styles from "./Tooltip.module.css";
import { attributeToTitle } from "src/utils/strings";

export const EntityTooltipModule: TooltipContentModule = {
  type: "entity",
  priority: 1,
  shouldRender: (context: TooltipContext) => {
    return context.type === "entity" && !!context.field?.target;
  },
  render: (context: TooltipContext) => {
    const { field, metadata, formattedValue } = context;
    if (!field?.target) return context.children;

    const entityType = attributeToTitle(field.attribute);
    const entityName = metadata?.entityName || formattedValue;
    const description = metadata?.description || metadata?.title;

    // Filter out metadata fields we've already displayed
    const excludedFields = new Set([
      "entityName",
      "entityAvatar",
      "description",
      "title",
    ]);
    const additionalMetadata = Object.entries(metadata || {})
      .filter(([key]) => !excludedFields.has(key))
      .filter(([_, value]) => value !== undefined && value !== null);

    const content = (
      <div className={styles.tooltip_container}>
        <div className={styles.tooltip_header}>{entityType}</div>

        <div className={styles.tooltip_section}>
          <div className={styles.tooltip_section_row}>
            {metadata?.entityAvatar &&
              metadata.entityAvatar !== "__VZBL::null__" && (
                <img
                  src={metadata.entityAvatar}
                  alt={entityName}
                  className={styles.tooltip_avatar}
                  width={24}
                  height={24}
                  style={{ borderRadius: "50%" }}
                />
              )}
          </div>
          <div className={styles.tooltip_row}>
            <div className={styles.tooltip_label}>Name</div>
            <span className={styles.tooltip_value}>{entityName}</span>
          </div>
          {description && (
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Description</div>
              <span className={styles.tooltip_value}>{description}</span>
            </div>
          )}
          {metadata?.title && (
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Title</div>
              <span className={styles.tooltip_value}>{metadata.title}</span>
            </div>
          )}
          {entityType && (
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Type</div>
              <span className={styles.tooltip_value}>{entityType}</span>
            </div>
          )}
        </div>

        {additionalMetadata.length > 0 && (
          <>
            <div className={styles.tooltip_divider}></div>
            <div className={styles.tooltip_section}>
              {additionalMetadata.map(([key, value]) => (
                <div key={key} className={styles.tooltip_row}>
                  <div className={styles.tooltip_label}>
                    {attributeToTitle(key)}
                  </div>
                  <span className={styles.tooltip_value}>
                    {typeof value === "object"
                      ? JSON.stringify(value)
                      : String(value)}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );

    return (
      <CustomTooltip content={content} placement="right" size="medium">
        {context.children}
      </CustomTooltip>
    );
  },
};
